var _circle, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGraphicPizzaBeginner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.1053,
    cy: 37.8947,
    r: 34.1053,
    transform: "rotate(-180 38.1053 37.8947)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 4.30733e-06C42.9902 4.74359e-06 47.9316 0.982908 52.542 2.89258C57.1523 4.80226 61.3414 7.60132 64.8701 11.13C68.3987 14.6586 71.1977 18.8477 73.1074 23.458C75.0171 28.0684 76 33.0098 76 38L42.56 38C42.56 37.4012 42.4421 36.8082 42.2129 36.255C41.9837 35.7017 41.6478 35.199 41.2244 34.7756C40.801 34.3522 40.2983 34.0163 39.745 33.7871C39.1918 33.5579 38.5988 33.44 38 33.44L38 4.30733e-06Z",
    fill: "#8C52FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76 38C76 42.7779 75.0989 47.513 73.3441 51.957L42.2413 39.6748C42.4519 39.1416 42.56 38.5734 42.56 38L76 38Z",
    fill: "#C9B3FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3749 51.8787C71.0788 57.7311 67.3666 62.9224 62.5709 66.9874L40.9485 41.4785C41.524 40.9907 41.9695 40.3677 42.245 39.6654L73.3749 51.8787Z",
    fill: "#EEE7FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1299 64.8701C5.54796 59.2881 1.84296 52.1062 0.529597 44.3221C-0.783764 36.538 0.359722 28.5381 3.80121 21.4337L33.8961 36.012C33.4832 36.8646 33.3459 37.8246 33.5036 38.7587C33.6612 39.6927 34.1058 40.5546 34.7756 41.2244L11.1299 64.8701Z",
    fill: "#462980"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicPizzaBeginner);
export default __webpack_public_path__ + "static/media/graphic-pizza-beginner.2270bfb7285ee2c24cfcc7fd0b7b14ce.svg";
export { ForwardRef as ReactComponent };